import changeInspectorReducer from "./changeInspectorReducer";

const changeReviewerReducers = {
    changeInspector: changeInspectorReducer,
}

export default changeReviewerReducers;